import script from "./SkyTooltipCaret.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyTooltipCaret.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__